import { render } from "./VisualizedPrivacy.vue?vue&type=template&id=35b348a8&scoped=true"
import script from "./VisualizedPrivacy.vue?vue&type=script&lang=js"
export * from "./VisualizedPrivacy.vue?vue&type=script&lang=js"

import "./VisualizedPrivacy.vue?vue&type=style&index=0&id=35b348a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b348a8"]])

export default __exports__